import { Component, Input } from '@angular/core';
import { BaseModalComponent } from './base-modal.component';

export interface HoursDrilldownRow {
  reporteddate: string;
  customername: string | null;
  endcustomer?: string | null;
  project_name: string | null;
  activity_name: string;
  hours: number;
}

export interface HoursDrilldownModalConfig {
  title: string;
  rows: HoursDrilldownRow[];
}

@Component({
  selector: 'app-hours-drilldown-modal',
  template: require('./hours-drilldown-modal.component.html').default,
  styles: [
    require('!!raw-loader!sass-loader!./base-modal.component.scss').default,
    require('!!raw-loader!sass-loader!./hours-drilldown-modal.component.scss').default,
  ],
  animations: [BaseModalComponent.modalAnimations[0]],
  standalone: false,
})
export class HoursDrilldownModalComponent extends BaseModalComponent {
  @Input() title = 'Tiddetaljer';
  @Input() rows: HoursDrilldownRow[] = [];
  @Input() closeButtonText = 'Stäng';

  configure(config?: HoursDrilldownModalConfig): void {
    this.title = config?.title || this.title;
    this.rows = config?.rows || [];
  }

  formatCustomerProject(row: HoursDrilldownRow): string {
    const customer = row.endcustomer && row.endcustomer.trim() !== ''
      ? `${row.endcustomer} (${row.customername || ''})`
      : (row.customername || '');
    if (!row.project_name) {
      return customer;
    }
    return customer ? `${customer} / ${row.project_name}` : row.project_name;
  }
}
